/**
 * RcmPlatform work model — Task Manager is the system of record for work queue items.
 *
 * Task Manager (PlatformServices/TaskManager): SSOT for queue items — assignment, status,
 * routing to target RCM services. Domain services create/update items via POST/PATCH;
 * service UIs list the same rows filtered by target_service / type.
 *
 * Work Queue (Agentic shells): unified inbox over Task Manager only.
 *
 * Team queue goals (SaaS Foundation): per-service throughput targets for humans and Kai.
 */

/** Short line under “Work Queue” in AgenticRCM. */
export const WORK_QUEUE_SHELL_SUBTITLE =
  'Unified inbox from Task Manager. Every RCM service queue shows the same items for this organization.';

/** Short line under “Work Queue” in AgenticPractice. */
export const PRACTICE_WORK_QUEUE_SHELL_SUBTITLE =
  'Unified inbox from Task Manager across Practice queues (appointment requests, waitlist, and more).';

/** Lead line for Agency Work Queue (pair with org-selection copy). */
export const WORK_QUEUE_AGENCY_LEAD =
  'Task Manager is the single source of truth for work across organizations. Service queues stay in sync with the same items.';

/** Task Manager page — how it relates to the Work Queue. */
export const TASK_MANAGER_SHELL_SUBTITLE =
  'System of record for work queue tasks. The Work Queue inbox and each RCM service queue read from here.';

/** Team queue goals page — ties goals to queues and tasks. */
export const TEAM_QUEUE_GOALS_INTRO =
  'App-level throughput targets per RCM service for teammates and Kai. Progress shows in each service’s queue and analytics. Goals complement Task Manager and the unified Work Queue: they set how much to complete; tasks and queue rows are the actual work.';
